import SparkMD5 from 'spark-md5';

export function computeMd5(buffer: ArrayBuffer): string {
  return SparkMD5.ArrayBuffer.hash(buffer);
}
